var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge bg-dark color-white mr-10"},[(_vm.course.institution)?[_vm._v(" "+_vm._s(_vm.course.institution.shortName)+" ")]:[_vm._v(" "+_vm._s(_vm.$t('course.oko'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }